import useGetApi from 'src/api/useGetApi';
import { InboundEmailDTO } from 'src/types/application/InboundEmailDTO';

const useGetInboundEmail = (inboundEmailId: string, enabled = true) => {
  return useGetApi<InboundEmailDTO>({
    endpoint: `communications/inbound-emails/${inboundEmailId}`,
    options: {
      enabled: enabled && !!inboundEmailId,
    },
  });
};

export default useGetInboundEmail;
